export function shouldPublishToBestFriends(
  enabled: boolean,
  bestFriendsCount: number,
): boolean {
  return enabled && bestFriendsCount > 0;
}

export function shouldOpenBestFriendsPicker(bestFriendsCount: number): boolean {
  return bestFriendsCount === 0;
}
